import React from "react";
import commonStyles from "../common/commonStyles/table.module.css";
import styles from "./index.module.css";
import CreatedTaskDetailsModal from "../workTablePatients/CreatedTaskDetailsModal";
import {MappingSection, RunSettingsSection, TaskStatusSection, UploadStepSection} from "./ImportDataSections";
import {Message, Segment, Header} from "semantic-ui-react";
import {useImportDataPage} from "./useImportDataPage";

const ImportDataPage = () => {
    const stylesMerged = { ...commonStyles, ...styles };
    const {
        entityType,
        file,
        session,
        mapping,
        createdTask,
        uploading,
        executing,
        error,
        infoMessage,
        taskId,
        task,
        taskLoading,
        skipErrors,
        detailedLog,
        defaultDoctorId,
        doctorOptions,
        loadingDoctors,
        mappingOptions,
        mappingError,
        configOptions,
        selectedConfigId,
        loadingConfigs,
        savingConfig,
        deletingConfig,
        canSaveCurrentConfig,
        isUidMapped,
        isImportEnabled,
        doctorSelectionError,
        canStartImport,
        usedTargets,
        handleEntityChange,
        handleFileChange,
        readFileAndPreview,
        resetSession,
        onMappingChange,
        onConfigSelect,
        saveCurrentConfig,
        deleteSelectedConfig,
        refreshTaskStatus,
        startImport,
        setDefaultDoctorId,
        setSkipErrors,
        setDetailedLog,
        closeCreatedTask,
    } = useImportDataPage();

    return (
        <div className={stylesMerged.container}>
            {createdTask && <CreatedTaskDetailsModal task={createdTask} onClose={closeCreatedTask} />}

            {!isImportEnabled && (
                <Segment>
                    <Header>Загрузка данных</Header>
                    <Message warning>Модуль импорта данных отключен в конфигурации.</Message>
                </Segment>
            )}

            {isImportEnabled && (
                <>
                    <Header>Загрузка данных</Header>
                    <UploadStepSection
                        entityType={entityType}
                        file={file}
                        uploading={uploading}
                        executing={executing}
                        hasSession={!!session}
                        onEntityChange={handleEntityChange}
                        onFileChange={handleFileChange}
                        onUpload={readFileAndPreview}
                        onReset={resetSession}
                    />

                    {error && <Message negative>{error}</Message>}
                    {infoMessage && <Message positive>{infoMessage}</Message>}

                    {!!session && (
                        <>
                            <MappingSection
                                entityType={entityType}
                                session={session}
                                mapping={mapping}
                                mappingOptions={mappingOptions}
                                mappingError={mappingError}
                                configOptions={configOptions}
                                selectedConfigId={selectedConfigId}
                                loadingConfigs={loadingConfigs}
                                savingConfig={savingConfig}
                                deletingConfig={deletingConfig}
                                canSaveCurrentConfig={canSaveCurrentConfig}
                                usedTargets={usedTargets}
                                onMappingChange={onMappingChange}
                                onConfigSelect={onConfigSelect}
                                saveCurrentConfig={saveCurrentConfig}
                                deleteSelectedConfig={deleteSelectedConfig}
                            />
                            <RunSettingsSection
                                entityType={entityType}
                                isUidMapped={isUidMapped}
                                defaultDoctorId={defaultDoctorId}
                                doctorOptions={doctorOptions}
                                loadingDoctors={loadingDoctors}
                                doctorSelectionError={doctorSelectionError}
                                skipErrors={skipErrors}
                                detailedLog={detailedLog}
                                executing={executing}
                                canStartImport={canStartImport}
                                onDefaultDoctorChange={setDefaultDoctorId}
                                onSkipErrorsChange={setSkipErrors}
                                onDetailedLogChange={setDetailedLog}
                                onStart={startImport}
                            />
                            {!!taskId && (
                                <TaskStatusSection
                                    taskId={taskId}
                                    task={task}
                                    taskLoading={taskLoading}
                                    onRefresh={refreshTaskStatus}
                                />
                            )}
                        </>
                    )}
                </>
            )}
        </div>
    );
};

export default ImportDataPage;
